import React from "react";
import { useNavigate } from "react-router-dom";

const Terminate = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.icon}>🚫</div>

        <h2 style={styles.title}>Interview Terminated</h2>

        <p style={styles.text}>
          Your interview has been terminated due to violation of rules 
          (such as tab switching or screen behavior).
        </p>

        <p style={styles.subText}>
          You are not allowed to rejoin this interview.
        </p>

        <button style={styles.button} onClick={() => navigate("/")}>
          Go to Home
        </button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#f5f7fa",
  },
  card: {
    background: "#fff",
    padding: "40px",
    borderRadius: "16px",
    textAlign: "center",
    maxWidth: "400px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
  },
  icon: {
    fontSize: "50px",
    marginBottom: "10px",
  },
  title: {
    color: "#DC2626",
    marginBottom: "10px",
  },
  text: {
    color: "#444",
    fontSize: "14px",
    marginBottom: "10px",
  },
  subText: {
    color: "#888",
    fontSize: "13px",
    marginBottom: "20px",
  },
  button: {
    background: "#1565C0",
    color: "#fff",
    border: "none",
    padding: "10px 20px",
    borderRadius: "8px",
    cursor: "pointer",
  },
};

export default Terminate;